export default __webpack_public_path__ + "static/media/wind-turbine-icon.d6e99ef0.svg";